import React, { useState } from 'react';
import moment from 'moment';
import { Modal, ModalContent, ModalWrapper, RangePicker } from '@workboard/wobo-ui';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  ${ModalWrapper} {
    .CalendarDay div {
      box-sizing: inherit;
    }
    ${ModalContent} {
      overflow-y: visible;
    }
  }
`;

type SaveUserTimeOffResponse = {
  id: string,
  uid: string,
  start_date: number,
  end_date: number,
  status: 'success',
} | {
  status: 'exist' | 'failed',
};

type UpdateSchDateResponse = {
  id: string,
  startDate: number,
  endDate: number,
  status: 'success',
} | {
  status: 'exist' | 'failed',
};

type Props = {
  dataList: {
    id: string,
    startDate: number,
    endDate: number,
  },
  actions: {
    UpdateUserTimeOff: (timePeriodId: string, UpdateSchDateResponse) => void,
    AddUserTimeOff: (SaveUserTimeOffResponse) => void,
  },
  closeScheduledTime: Function,
};

const ScheduledPopUp = ({ dataList, actions, closeScheduledTime }: Props) => {
  const [startDateYear, startDateMonth, startDateDay] = moment.unix(dataList.startDate).utc().toArray();
  const [endDateYear, endDateMonth, endDateDay] = moment.unix(dataList.endDate).utc().toArray();
  const startDate = dataList.startDate ? new Date(startDateYear, startDateMonth, startDateDay) : new Date();
  const endDate = dataList.endDate ? new Date(endDateYear, endDateMonth, endDateDay) : new Date();

  const [start, setStart] = useState(startDate);
  const [end, setEnd] = useState(endDate);

  const timePeriodId = dataList.id;
  const isScheduleUpdate = timePeriodId != '' && timePeriodId != undefined;

  const saveScheduledTime = () => {
    const startDateFor = moment(start.valueOf()).format('M/D/YYYY');
    const endDateFor = moment(end.valueOf()).format('M/D/YYYY');

    const params = { start_date: startDateFor, end_date: endDateFor } as any;
    let url = '';
    if (isScheduleUpdate) {
      params.id = timePeriodId;
      url = `${wbConfig.baseUrl}/user/profile/updateSchDate`;
    } else {
      url = `${wbConfig.baseUrl}/user/profile/SaveUserTimeOff`;
    }
    const getAjaxSetup = $.ajaxSetup as Function;
    if (getAjaxSetup().data.YII_CSRF_TOKEN) {
      params.YII_CSRF_TOKEN = getAjaxSetup().data.YII_CSRF_TOKEN;
    }
    $.post(url, params, function (response, status) {
      if (status == 'success') {
        if (isScheduleUpdate) {
          actions.UpdateUserTimeOff(timePeriodId, response);
        } else {
          actions.AddUserTimeOff(response);
        }
        closeScheduledTime();
      }
    });
  }

  const handleRangeChange = ({ start, end }) => {
    if (start && end) {
      const s = start.getTime();
      const e = end.getTime();
      if (s > e) {
        setStart(end);
        setEnd(null);
      } else {
        setStart(start);
        setEnd(end);
      }
    }
  }

  return (
    <StyledModal
      title='Schedule Time off'
      kind='normal'
      submitLabel={isScheduleUpdate ? 'Update' : 'Add'}
      disableDismiss
      isOpen={true}
      onDismiss={closeScheduledTime}
      onSubmit={saveScheduledTime}
      disableScrollLock={true}
    >
      <RangePicker
        keepOpen
        displayFormat={() => 'DD/MM/YYYY'}
        start={start}
        end={end}
        showClearDates={false}
        anchorDirection='center'
        onChange={handleRangeChange}
      />
    </StyledModal>
  );
}

export {
  ScheduledPopUp,
}